// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".merge-guest-page .different-email-description[data-v-763e4dfd]{font-size:13px}.merge-guest-page .show-modal-button[data-v-763e4dfd]{font-size:13px;padding:0 4px}", ""]);
// Exports
module.exports = exports;
